export var EventDataKeys;
(function (EventDataKeys) {
    EventDataKeys["IsTimeShown"] = "data-time-shown";
    EventDataKeys["IsFullDay"] = "data-fullday";
    EventDataKeys["IsRightToLeft"] = "data-right-to-left";
    EventDataKeys["IsSelected"] = "data-selected";
    EventDataKeys["ARIA_Has_Popup"] = "aria-haspopup";
    EventDataKeys["ARIA_Expanded"] = "aria-expanded";
})(EventDataKeys || (EventDataKeys = {}));
//# sourceMappingURL=types.js.map